module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "app"
  }, [_c('div', {
    staticClass: "row center-block"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header col-md-2"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-header col-md-8 text-center"
  }, [(_vm.client.clientId) ? _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.clientId),
      expression: "client.clientId"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.clientId)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "clientId", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.client.clientSecret),
      expression: "client.clientSecret"
    }],
    staticClass: "form-control",
    attrs: {
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": (_vm.client.clientSecret)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.client, "clientSecret", $event.target.value)
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "box-header col-md-2 text-right"
  }, [_c('button', {
    class: 'btn btn-lg btn-primary',
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": _vm.targetModalId,
      "data-placement": "top",
      "title": _vm.$t('add')
    },
    on: {
      "click": function($event) {
        _vm.$_admin_app_action_c()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  Add\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "dataTables_wrapper form-inline dt-bootstrap",
    attrs: {
      "id": "example_wrapper"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 table-responsive"
  }, [_c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('v-server-table', {
    attrs: {
      "url": "/",
      "columns": _vm.columns,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "checkbox",
      fn: function(props) {
        return [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (_vm.markedRows),
            expression: "markedRows"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "value": props.row.appId,
            "checked": Array.isArray(_vm.markedRows) ? _vm._i(_vm.markedRows, props.row.appId) > -1 : (_vm.markedRows)
          },
          on: {
            "change": [function($event) {
              var $$a = _vm.markedRows,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = props.row.appId,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.markedRows = $$a.concat([$$v]))
                } else {
                  $$i > -1 && (_vm.markedRows = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
                }
              } else {
                _vm.markedRows = $$c
              }
            }, function($event) {
              _vm.$_admin_app_list_unmarkAll()
            }]
          }
        })]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "filter__checkbox"
    },
    slot: "filter__checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.allMarked),
      expression: "allMarked"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.allMarked) ? _vm._i(_vm.allMarked, null) > -1 : (_vm.allMarked)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.allMarked,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.allMarked = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.allMarked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.allMarked = $$c
        }
      }, function($event) {
        _vm.$_admin_app_list_toggleAll()
      }]
    }
  }), _vm._v("\n                                             \n                                            "), _c('button', {
    staticClass: "btn btn-danger btn-sm",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "top",
      "title": _vm.$t('deleteSelected')
    },
    on: {
      "click": function($event) {
        _vm.$_admin_app_list_removeAll()
      }
    }
  }, [_c('i', {
    staticClass: "glyphicon glyphicon-trash"
  })])])])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal modal-info fade",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": _vm.modalId
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_vm._m(5), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].addApp))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('form', {
    staticClass: "ui form addAppForm"
  }, [_c('div', {
    staticClass: "row",
    class: {
      'has-error2': _vm.$v.newApp.keyName.$invalid
    }
  }, [_c('div', {
    staticClass: "col-md-3 text-left"
  }, [_c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("\n                                            " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].keyName) + " :\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newApp.keyName),
      expression: "newApp.keyName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "key",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newApp.keyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newApp, "keyName", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: {
      'has-error2': _vm.$v.newApp.platform.$invalid
    }
  }, [_c('div', {
    staticClass: "col-md-3 text-left"
  }, [_c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("\n                                            " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].platform) + " :\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newApp.platform),
      expression: "newApp.platform"
    }],
    attrs: {
      "id": "platform1",
      "value": "android",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.newApp.platform, "android")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.newApp, "platform", "android")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "platform1"
    }
  }, [_vm._v("android")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newApp.platform),
      expression: "newApp.platform"
    }],
    attrs: {
      "id": "platform2",
      "value": "ios",
      "type": "radio"
    },
    domProps: {
      "checked": _vm._q(_vm.newApp.platform, "ios")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.newApp, "platform", "ios")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "platform2"
    }
  }, [_vm._v("ios")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: {
      'has-error2': _vm.$v.newApp.publishSecret.$invalid
    }
  }, [_c('div', {
    staticClass: "col-md-3 text-left"
  }, [_c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("\n                                            " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].publishSecret) + " :\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newApp.publishSecret),
      expression: "newApp.publishSecret"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "key",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newApp.publishSecret)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newApp, "publishSecret", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3 text-left"
  }, [_vm._v(_vm._s(_vm.$i18n.messages[_vm.$i18n.locale].testSecret) + " :")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newApp.testSecret),
      expression: "newApp.testSecret"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "key",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newApp.testSecret)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newApp, "testSecret", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    class: {
      'has-error2': _vm.$v.newApp.packageName.$invalid
    }
  }, [_c('div', {
    staticClass: "col-md-3 text-left"
  }, [_c('label', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("*")]), _vm._v("\n                                            " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].package) + " :\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newApp.packageName),
      expression: "newApp.packageName"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "key",
      "type": "text"
    },
    domProps: {
      "value": (_vm.newApp.packageName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newApp, "packageName", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-outline",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$_admin_app_add_checkAddApp()
      }
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$i18n.messages[_vm.$i18n.locale].submit) + "\n                                ")])])])]), _vm._v(" "), _c('div', {
    class: {
      overlay: true, hidden: !_vm.loading
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  })])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 divDeveloperDocumentation"
  }, [_c('h1', {
    staticClass: "developerDocumentationSdk  nuwaDevelop"
  }, [_vm._v("Nuwa Robot SDK")]), _vm._v(" "), _c('h1', {
    staticClass: "developerDocumentationDer  nuwaDevelop"
  }, [_vm._v("Ver 0.37")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 divDeveloperDocumentationDownload"
  }, [_c('h3', {
    staticClass: "developerDocumentationDownload nuwaDevelop"
  }, [_vm._v("Download")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-12 div_path_3"
  }, [_c('button', {
    staticClass: "rectangle_9"
  }, [_c('span', {
    staticClass: "buttonTxt"
  }, [_vm._v("SDK")])]), _vm._v(" "), _c('button', {
    staticClass: "rectangle_9"
  }, [_c('span', {
    staticClass: "buttonTxt"
  }, [_vm._v("Sample Code")])]), _vm._v(" "), _c('button', {
    staticClass: "rectangle_9"
  }, [_c('span', {
    staticClass: "buttonTxt"
  }, [_vm._v("PDF")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("client id:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-md-2"
  }, [_c('label', [_vm._v("client secret:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eb185e42"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Build.vue
// module id = 1509
// module chunks = 1